export type SeoLocationDescriptor = {
  countryUrlPrefix: string;
  citySlug: string;
  regionSlug: string;
  serviceTypeSlug: string;
  neighborhoodSlug?: string;
};

export function parseSeoLocationFromTopLevelSlug(
  seoLocationSlug: string,
  overrideCountryUrlPrefix?: string
): SeoLocationDescriptor {
  let countryUrlPrefix;
  let citySlug;
  let regionSlug;
  let serviceTypeSlug;
  let neighborhoodSlug;
  let locationSlug = '';

  // Get country code and "actual" slug from top-level slug (which might start with country code and forward slash)
  const topLevelParts = seoLocationSlug.split('/');
  if (topLevelParts.length === 2) {
    [countryUrlPrefix, locationSlug] = topLevelParts;
  } else if (topLevelParts.length === 1 && topLevelParts[0].split('--').length >= 3) {
    [countryUrlPrefix, locationSlug] = [overrideCountryUrlPrefix ?? 'us', ...topLevelParts];
  }

  // Now get the location parts from the "actual" slug
  const locationParts = locationSlug.split('--');
  if (locationParts.length === 4) {
    [neighborhoodSlug, citySlug, regionSlug, serviceTypeSlug] = locationParts;
  } else if (locationParts.length === 3) {
    [neighborhoodSlug, citySlug, regionSlug, serviceTypeSlug] = [null, ...locationParts];
  }

  return {
    countryUrlPrefix,
    citySlug,
    regionSlug,
    serviceTypeSlug,
    neighborhoodSlug,
  };
}
